import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import styles from './PayoutDetails.module.css';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/Common/Header/Header';
import Badge from '../../components/Badge/Badge';
import { setCanRefresh } from '../../actions/appActions';
import useBodyLock from '../../hooks/useBodyLock';
import BadgePayments from '../../components/Badge/BadgePaymentDetails';
import Money from '../../components/Common/Money/Money';

export default function PayoutDetails() {
  useBodyLock();
  const location = useLocation();
  const { t } = useTranslation();
  const appCanRefresh = useSelector((state) => state.app.canRefresh);
  const dispatch = useDispatch();
  const payoutDate = location?.state?.payout;
  useEffect(() => {
    if (appCanRefresh === true) {
      dispatch(setCanRefresh(false));
      return () => {
        dispatch(setCanRefresh(true));
      };
    }
  }, []);
  return (
    <div className={styles.payoutDetailsPage}>
      <Header title={t('paymentDetails')} />

      <main className={styles.contentArea}>
        <div className='mb-2'>
          <p className={` ${styles.amountText} fw-700 `}>
            +<Money value={payoutDate.amount} /> {payoutDate.currency}
          </p>
        </div>

        <BadgePayments
          text={t(`badge.${payoutDate.status}`)}
          type={payoutDate?.status.toLowerCase()}
        />

        <div className={styles.detailsCard}>
          <div className='fw-700 font-1rem mt-1 mb-1'>{t('transactionDetails.title')}</div>
          <div className={styles.separator}></div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.amount')}</span>
            <span className='fw-400 font-1rem'>
              <Money value={payoutDate.amount} /> {payoutDate.currency}
            </span>
          </div>
          <div className={styles.separator}></div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.sentDate')}</span>
            <span className='fw-400 font-tiny'>
              {new Date(payoutDate.createdDate)
                .toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })
                .replace(',', '')}
            </span>
          </div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.estimatedArrival')}</span>
            <span className='fw-400 font-tiny'>
              {new Date(payoutDate.arrivalDate)
                .toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })
                .replace(',', '')}
            </span>
          </div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.bank')}</span>
            <span className='fw-400 font-tiny'>{payoutDate.bankName}</span>
          </div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.status')}</span>
            <span className='fw-400 font-tiny'>{t(`badge.${payoutDate.status}`)}</span>
          </div>

          <div className={styles.detailRow}>
            <span className='fw-400 font-tiny'>{t('transactionDetails.accountNumber')}</span>
            <span className='fw-400 font-tiny'>•••• {payoutDate.last4}</span>
          </div>
        </div>
      </main>
    </div>
  );
}
